import _styled from "styled-components";
const _excluded = ["style", "className", "now", "children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import styledC, { css, keyframes } from 'styled-components';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
const indeterminateKeyFrames = keyframes(["0%{left:-50%;}100%{left:100%;}"]);
const animationCss = css(["", " 1.3s linear infinite;"], indeterminateKeyFrames);
const linearGradientBackground = `linear-gradient(90deg, rgba(56, 171, 223, 0) 0%, ${theme.tokens.colors.icon.load.value} 100%)`;
const solidBackground = theme.tokens.colors.icon.load.value;
const StyledProgressBar = styledC.div.withConfig({
  displayName: "ProgressBar__StyledProgressBar",
  componentId: "sc-1lxwziq-0"
})(["width:", "%;height:4px;position:absolute;left:0;bottom:0;top:0;transition:width 0.2s linear;transformorigin:left;background:", ";'&:after':{top:-2px;height:6px;width:6px;content:\"' '\";display:block;position:absolute;right:", ";transform:rotate(200deg);backgroundcolor:", ";}animation:", ";"], props => props.$indeterminate ? 50 : Math.min(props.$now, 100), props => props.$indeterminate ? linearGradientBackground : solidBackground, props => props.$now === 0 ? 0 : -2, theme.tokens.colors.icon.load.value, props => props.$indeterminate && animationCss);
/**
 * Provide up-to-date feedback on the ProgressBar of a workflow or action
 * with simple yet flexible ProgressBar.
 */
const ProgressBar = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      style,
      className,
      now = NaN,
      children
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const indeterminate = isNaN(now);
  return /*#__PURE__*/React.createElement(_StyledDiv, _extends({
    role: "progressbar",
    "aria-label": "progressbar",
    "aria-valuetext": indeterminate ? 'indeterminate' : undefined,
    "aria-valuenow": indeterminate ? undefined : now,
    "aria-valuemin": 0,
    "aria-valuemax": 100
  }, props, {
    ref: ref,
    className: className,
    $_css: [{
      position: 'relative',
      width: '100%',
      borderRadius: theme.borderRadius.small,
      height: 4,
      overflow: 'hidden',
      background: theme.tokens.colors.background.neutral.inactive.value
    }, style]
  }), /*#__PURE__*/React.createElement(StyledProgressBar, {
    $indeterminate: indeterminate,
    $now: now
  }, children));
});
ProgressBar.displayName = 'ProgressBar';
ProgressBar.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /**  The component's children */
  children: PropTypes.any,
  /**  Current value of ProgressBar */
  now: PropTypes.number
};
export default ProgressBar;
var _StyledDiv = styledC("div").withConfig({
  displayName: "ProgressBar___StyledDiv",
  componentId: "sc-1lxwziq-1"
})(["", ""], p => p.$_css);
//# sourceMappingURL=ProgressBar.js.map